module.exports = __webpack_public_path__ + "img/02_full.f85637c4.jpg";